<header class="header">
  <h1>
    <fa-icon [icon]="faUsersCog"></fa-icon>
    <span>HR Panel Administration</span>
  </h1>
</header>

<div class="container">
  <div class="auth-container">
    <div class="auth-form">
      <div class="tabs">
        <div class="tab active">
          <fa-icon [icon]="faSignInAlt"></fa-icon>
          <span>Login</span>
        </div>
      </div>
      
      <div class="tab-content active">
        <div class="form-header">
          <h2>
            <fa-icon [icon]="faLock"></fa-icon>
            <span>Admin Login</span>
          </h2>
          <p>Sign in to access the HR administration panel</p>
        </div>
        
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="username">
              <fa-icon [icon]="faUser"></fa-icon>
              <span>Username</span>
            </label>
            <input 
              type="text" 
              id="username" 
              formControlName="username"
              placeholder="Enter your username"
              [ngClass]="{'is-invalid': loginForm.get('username')?.invalid && loginForm.get('username')?.touched}"
            >
            <div class="invalid-feedback" *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched">
              <div *ngIf="loginForm.get('username')?.errors?.['required']">Username is required</div>
              <div *ngIf="loginForm.get('username')?.errors?.['minlength']">Username must be at least 3 characters</div>
            </div>
          </div>
          <div class="form-group">
            <label for="password">
              <fa-icon [icon]="faKey"></fa-icon>
              <span>Password</span>
            </label>
            <input 
              type="password" 
              id="password" 
              formControlName="password"
              placeholder="Enter your password"
              [ngClass]="{'is-invalid': loginForm.get('password')?.invalid && loginForm.get('password')?.touched}"
            >
            <div class="invalid-feedback" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
              <div *ngIf="loginForm.get('password')?.errors?.['required']">Password is required</div>
              <div *ngIf="loginForm.get('password')?.errors?.['minlength']">Password must be at least 6 characters</div>
            </div>
          </div>
          <button type="submit" class="btn" [disabled]="isLoading || loginForm.invalid">
            <fa-icon [icon]="faSignInAlt"></fa-icon>
            <span>{{ isLoading ? 'Logging in...' : 'Login' }}</span>
          </button>
        </form>

        <div *ngIf="errorMessage" class="result-message error">
          <h3>
            <fa-icon [icon]="faExclamationCircle"></fa-icon>
            <span>Login failed</span>
          </h3>
          <p>{{ errorMessage }}</p>
        </div>

        <div *ngIf="successMessage" class="result-message success">
          <h3>
            <fa-icon [icon]="faCheckCircle"></fa-icon>
            <span>Login successful!</span>
          </h3>
          <p>You are now logged in as <strong>{{ username }}</strong> with role <strong>{{ userRole }}</strong>.</p>
          <div class="token-display" *ngIf="authToken">
            <p>Your authentication token: <small><code>{{ authToken }}</code></small></p>
          </div>
          <p style="text-align: center; margin-top: 1rem; color: var(--success);">Redirecting to dashboard in 2 seconds...</p>
        </div>
      </div>
    </div>
  </div>
</div> 